import LaunchingPanel from './LaunchingPanel.view';

export default LaunchingPanel;
